import React, { useState, useEffect } from 'react'
import { Text, View, StyleSheet, Font } from '@react-pdf/renderer'
import ScaleBarPulse from './ScaleBarPulse'
import TableGridPulse from './TableGridPulse'
import PointersPulse from './PointersPulse'

Font.registerHyphenationCallback(word => [word]);

const styles = StyleSheet.create({
    categoryText: {
        paddingLeft: '5%',
        paddingRight: '5%',
        marginTop: 25,
    },
    tableHeader: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        paddingLeft: '5%',
        paddingRight: '5%',
        backgroundColor: 'rgb(226 232 240)',
    },
    tableHeaderTitle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        paddingTop: 5,
        paddingBottom: 5,
    },
    tableHeaderTitleText1: {
        fontFamily: 'Inter',
        fontSize: 15,
        fontWeight: 500,
        marginRight: 5,
    },
    tableHeaderTitleText2: {
        fontFamily: 'Inter',
        fontSize: 12,
    },
    tableContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        borderBottom: '1 solid rgb(226 232 240)',
    },
    tableFirstCol: {
        width: '60%',
        backgroundColor: '#ffffff',
    },
    tableFirstColAnswer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        width: '100%',
    },
    tableFirstColAnswerNumber: {
        width: '10%',
        paddingLeft: 3,
        paddingRight: 3,
        marginTop: -1,
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    tableFirstColAnswerText: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '75%',
        paddingRight: 10,
        paddingTop: 0,
        paddingBottom: 3,
    },
    tableFirstColAnswerPoints: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '22%',
        height: '100%',
        textAlign: 'right',
        paddingLeft: 5,
        paddingRight: 5,
    },
    tableLastCol: {
        width: '40%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: 'rgb(226 232 240)',
        borderBottom: '1 solid #fff',
        paddingRight: 7,
        opacity: 0.7,
    },
    tableLastColRows: {
        width: '100%',
        flexDirection: 'row',
        height: 15,
    },
    scaleBarContainer: {
        position: 'relative',
        zIndex: 50,
        display: 'flex',
        flexDirection: 'row',
    },
    gridContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: '5.5%',
        top: -1,
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1 solid rgb(226 232 240)',
    },
    gridContainer2: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        right: '5.5%',
        top: -1,
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1 solid rgb(226 232 240)',
    },
    legendContainer: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingLeft: '5%',
        paddingRight: '5%',
        marginTop: 20,
    },
    legendText: {
        fontFamily: 'Inter',
        fontSize: 8,
        fontWeight: 400,
    },
    legendLine: {
        height: 0,
        width: 12,
        borderTop: '1 dashed black',
    }
});

const AnswersTablePulse = ({ answersData, categoriesData, matchCategory, spaceTop, spaceBottom, uiData }) => {

    const current = uiData.current;
    const currentText = `(${current})`;

    const [matchedCategory, setMatchedCategory] = useState(null);
    const [answersFromCategory, setAnswersFromCategory] = useState([]);

    const roundToTwoDecimals = (num) => {
        const rounded = Math.round(num * 100) / 100;
        return rounded % 1 === 0 ? `${rounded}.00` : rounded.toFixed(2);
    }; 

    useEffect(() => {
        if (answersData && categoriesData) {
            const categoryData = categoriesData.find(item => item.name === matchCategory);
            setMatchedCategory(categoryData);

            if (matchCategory === uiData.lowest) {
                const allAnswers = [...answersData];
                const lowestPoints = allAnswers.sort((a, b) => a.points - b.points);
                const result = lowestPoints.slice(0, 10);
                setAnswersFromCategory(result);
            } else if (matchCategory === uiData.highest) {
                const allAnswers = [...answersData];
                const highestPoints = allAnswers.sort((a, b) => b.points - a.points);
                const result = highestPoints.slice(0, 10);
                setAnswersFromCategory(result);
            } else {
                const result = answersData.filter(item => item.category === matchCategory);
                setAnswersFromCategory(result);
            }
        }
    }, [answersData, categoriesData, matchCategory, uiData.lowest, uiData.highest]);


    return (
        <>

            <View style={styles.tableHeader}>
                <View style={styles.tableHeaderTitle}>
                    <Text style={styles.tableHeaderTitleText1}>{matchCategory}</Text>
                    <Text style={styles.tableHeaderTitleText2}>{currentText}</Text>
                </View>
                {matchedCategory && (
                    <View
                        style={{
                            color: '#ffffff',
                            fontFamily: 'Inter',
                            fontSize: 18,
                            fontWeight: 700,
                            padding: 5,
                            backgroundColor: roundToTwoDecimals(matchedCategory.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(matchedCategory.points) <= 3 ? "#eac714" : (roundToTwoDecimals(matchedCategory.points) <= 5 ? "#7bb662" : "#639754")),
                        }}
                    >
                        <Text>{roundToTwoDecimals(matchedCategory.points)}</Text>
                    </View>
                )}
            </View>
            <View style={{
                display: 'flex',
                flexDirection: 'column',
            }}>
                {matchedCategory && (
                    <View style={styles.categoryText}>
                        {matchedCategory.description.map((item, index) => {
                            switch (item.type) {
                                case 'paragraph':
                                    return <Text
                                        key={index}
                                        style={{
                                            display: 'block',
                                            fontFamily: 'Inter',
                                            fontSize: 9,
                                            lineHeight: 1.4,
                                            marginBottom: 10,
                                        }}>{item.text}</Text>;
                                default:
                                    return null;
                            }
                        })}

                    </View>
                )}

                <View style={{
                    position: 'relative',
                    paddingLeft: '5%',
                    paddingRight: '5%',
                    marginTop: spaceTop,
                    marginBottom: spaceBottom,
                    width: '100%',
                }}>
                    <View style={styles.gridContainer} zIndex={9999}>
                        <View style={{ width: '60%' }}></View>
                        <View style={{ width: '40%' }}>
                            <TableGridPulse />
                        </View>
                    </View>

                    {answersFromCategory.map(

                        ({ id, answer, points, m, s }, index) => {

                            const roundedPoints = roundToTwoDecimals(points);
                            const xPos = ((roundedPoints - 1) / 4) * 100;

                            const xPosAv = roundToTwoDecimals(m);
                            const xPosMin = roundToTwoDecimals(m - s);
                            const xPosMax = roundToTwoDecimals(m + s);


                            const getBackgroundColor = (xPos, xPosMin, xPosMax, xPosAv) => {
                                if (roundedPoints <= xPosMin) {
                                    return 'rgb(220 38 38)';
                                } else if (roundedPoints > xPosMin && roundedPoints < xPosAv) {
                                    return '#eac714';
                                } else if (roundedPoints >= xPosMax) {
                                    return 'rgb(77 124 15)';
                                } else {
                                    return '#7bb662';
                                }
                            };

                            return (
                                <View key={id}>
                                    <View>
                                        <View style={styles.tableContainer}>
                                            <View style={styles.tableFirstCol}>
                                                <View style={styles.tableFirstColAnswer}>
                                                    <View style={styles.tableFirstColAnswerNumber}>
                                                        <Text
                                                            style={{
                                                                fontFamily: 'Inter',
                                                                fontSize: 10,
                                                                fontWeight: 600,
                                                                lineHeight: 1.1,
                                                            }}
                                                        >
                                                            F{(id >= 10 ? id + '.' : '0' + id + '.')}
                                                        </Text>
                                                    </View>
                                                    <View style={[styles.tableFirstColAnswerText, { height: 25, paddingBottom: 0 }]}>
                                                        <Text
                                                            style={{
                                                                fontFamily: 'Inter',
                                                                fontSize: 8,
                                                                lineHeight: 1.2,
                                                            }}
                                                        >
                                                            {(() => {
                                                                const fullText = answer;
                                                                const maxLength = 120;
                                                                return fullText.length > maxLength ? fullText.substring(0, maxLength) + '...' : fullText;
                                                            })()}
                                                        </Text>
                                                    </View>
                                                    <View style={styles.tableFirstColAnswerPoints}>
                                                        <Text
                                                            style={{
                                                                fontFamily: 'Inter',
                                                                fontSize: 10,
                                                                fontWeight: 700,
                                                                marginRight: 3,
                                                            }}
                                                        >
                                                            {roundedPoints}
                                                        </Text>
                                                        <Text
                                                            style={{
                                                                fontFamily: 'Inter',
                                                                fontSize: 9,
                                                                fontWeight: 500,
                                                                opacity: 0.5,
                                                                marginRight: 2,
                                                            }}
                                                        >
                                                            {` (Ø ${xPosAv})`}
                                                        </Text>
                                                    </View>
                                                </View>
                                            </View>
                                            <View style={styles.tableLastCol}>
                                                <View style={styles.tableLastColRows}>
                                                    <View
                                                        style={{
                                                            height: 6,
                                                            width: 6,
                                                            backgroundColor: getBackgroundColor(xPos, xPosMin, xPosMax, xPosAv),
                                                            borderRadius: '50%',
                                                            position: 'absolute',
                                                            left: `${xPos}%`,
                                                            top: 5,
                                                        }}
                                                    >
                                                    </View>
                                                </View>
                                            </View>
                                        </View>
                                    </View>
                                    <View style={styles.gridContainer2} zIndex={10}>
                                        <View style={{ width: '60%' }}></View>
                                        <View style={{ width: '40%' }}>
                                            <PointersPulse averagePoint={roundToTwoDecimals(m)} rangePoint={roundToTwoDecimals(s)} />
                                        </View>
                                    </View>
                                </View>
                            );
                        }
                    )}
                    <View style={styles.scaleBarContainer}>
                        <View style={{ width: '60%' }}></View>
                        <View style={{ width: '40%', marginBottom: 10 }}>
                            <ScaleBarPulse />
                        </View>
                    </View>
                    {matchCategory !== uiData.lowest && matchCategory !== uiData.highest && (
                        <View>
                            <Text
                                style={{
                                    fontFamily: 'Inter',
                                    fontSize: 7,
                                    fontWeight: 400,
                                }}
                            >
                                {uiData.averText}
                            </Text>
                        </View>
                    )}
                </View>
            </View>
        </>
    )
}

export default AnswersTablePulse